module.exports = __webpack_public_path__ + "static/media/frame light.8151f5a2.png";